import React from 'react';
import {Box, Flex} from "@chakra-ui/layout";
import Logo from "../utilities/Logo";
import {Heading, Link} from "@chakra-ui/react";
import {NavLink} from "react-router-dom";

function Footer() {
  return (
    <Flex flexDirection={"column"}>
      <Flex p={{base: 5, md: 7, lg: 10}} w={"100%"}>
        <Flex bg={"linear-gradient(179.99deg, #111827 0.01%, #F59E0B 613.93%);"} justifyContent={"space-between"} px={{base: 3, md: 5, lg: 8}}
              py={{base: 4, md: 7, lg: 12}} w={"100%"} borderRadius={"20px"}>
          <Heading as={"h3"} fontSize={{base: "lg", md: '2xl', lg: "4xl"}} textTransform={"capitalize"} color={"white"}>ready
            to join?</Heading>
          <Link as={NavLink} to={"/auth"} textTransform={"capitalize"} fontSize={{base: "md", lg: "lg"}} bgColor={"brand.darkGreen"}
                color={"white"} borderRadius={"30px"} w={{base: "150px", lg: "200px"}} d={"flex"} justifyContent={"center"} alignItems={"center"} py={{base: 2, lg: 4}}>
            register now
          </Link>
        </Flex>
      </Flex>

      <Flex justifyContent={"space-between"} py={12} px={{base: 2, md: 4, lg: 7}} bgColor={"brand.orange"} w={"100%"}>
        <Logo _fontSize={"2xl"} _mt={0}/>
        <Box>
          <i className={"fab fa-instagram fa-2x"}/>
          <i className={"fa fa-twitter-square fa-2x"}/>
        </Box>
      </Flex>
    </Flex>
  );
}

export default Footer;